import React from "react";
import { InterviewSidebarSection } from "../Components/InterviewSidebarSection";
import { RowWithSingleField, YesNoRow } from "../Components/SidebarComponents";
import { isNullOrWhitespace } from "../../../../services/stringService";

//TODO: Add appropriate logic here.
export const InterviewSidebarPatientInfoScreening = ({
    patientInfoScreening,
    patientAge,
    patientGender,
    maxChildAge,
    minFosterCareAge,
    maxFosterCareAge,
    ...props
}) => {
    return (
        <InterviewSidebarSection title={"Program Pre-Screening"} {...props}>
            <RowWithSingleField title={"Household Count"} value={patientInfoScreening.householdMemberCount || "N/A"} />
            <RowWithSingleField title={"Household Income"} value={patientInfoScreening.householdIncome || "N/A"} />
            <YesNoRow title="Has Child under 21?" isYes={patientInfoScreening.hasChildren === "Yes"} />
            {patientGender === "Female" && (
                <>
                    <YesNoRow
                        title="Has Breast/Cervical Cancer"
                        isYes={patientInfoScreening?.isBeingTreatedForBreastCancer}
                    />
                    {patientInfoScreening?.isBeingTreatedForBreastCancer && (
                        <>
                            <RowWithSingleField
                                title={"Screened at"}
                                value={
                                    <>
                                        {isNullOrWhitespace(patientInfoScreening?.clinicName)
                                            ? "Other"
                                            : patientInfoScreening?.clinicName}
                                    </>
                                }
                            />
                        </>
                    )}
                </>
            )}
            {patientAge <= maxChildAge && (
                <YesNoRow title={"Is in Foster Care"} isYes={patientInfoScreening?.inFosterCare} />
            )}
            {patientAge >= minFosterCareAge && patientAge <= maxFosterCareAge && (
                <YesNoRow title={"Aged out of foster care"} isYes={patientInfoScreening?.wasInFosterCareWhenTurned19} />
            )}
            {patientAge >= maxChildAge && patientAge <= maxFosterCareAge && (
                <YesNoRow title={"Is Full Time Student"} isYes={patientInfoScreening?.isFullTimeStudent} />
            )}
        </InterviewSidebarSection>
    );
};
